import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { FolderUpdatePayload } from 'Interfaces/Folder';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: FolderUpdatePayload) =>
    $actions.folder.updateFolder(dispatch, values),
  );
};
